import _ from 'underscore';
import appConfig from '@bingads-webui-component-legacy/config/index';
import {
  generateBaseBIColumns,
  getListOfRawBIColumns,
  RSAAdCustomizerAttributesColumn,
} from '@bingads-webui-campaign-legacy/campaigns-tab-campaigns/grid/columns-config-base';

const Permissions = appConfig.get('Permissions');
const isPortfolioBidStrategyEnabled = _.result(Permissions.dynamic, 'PortfolioBidStrategy');
const isBroadOnlyEnabled = _.result(Permissions.dynamic, 'BroadOnly');
const isPredictiveMatchingEnabled = _.result(Permissions.dynamic, 'PredictiveMatching');

const {
  IsAvgPositionDeprecationPhase1Enabled,
  IsExperimentsEnabled: showExperiment,
} = Permissions;

export const KeywordStatusColumn = {
  name: 'Status',
  property: _.compact([
    'Status',
    showExperiment && 'Campaign/ExperimentId',
  ]),
};

export const KeywordColumn = {
  name: 'Keyword',
  property: ['Text', 'Id', 'Labels', 'AdGroup/Id', 'Campaign/Id', 'RSAAdCustomizerAttributes'],
};

export const CampaignColumn = {
  name: 'Campaign',
  property: _.compact([
    'Campaign/Name',
    'Campaign/Id',
    showExperiment && 'Campaign/BaseCampaignName',
  ]),
};
export const AdGroupColumn = {
  name: 'AdGroup',
  property: ['AdGroup/Name', 'AdGroup/Id'],
};

export const BidStrategyNameColumn = {
  name: 'BidStrategyName',
  property: 'Campaign/BidStrategyName',
};

export const BidStrategyTypeColumn = {
  name: 'BidStrategyType',
  property: 'DisplayBiddingStrategyType',
};

export const BidColumn = {
  name: 'Bid',
  property: ['Bid/Amount', // currently require this will return whole bid object
    'IsBidLandscapeAvailable',
    'Campaign/CampaignType',
    'AdGroup/PricingModel',
    'DisplayBiddingStrategyType',
    'Campaign/Id',
    'AdGroup/Id'],
};

export const MatchTypeColumn = {
  name: 'MatchType',
  property: _.compact([
    'MatchType',
    (isBroadOnlyEnabled || isPredictiveMatchingEnabled) && 'Campaign/IsBroadMatchOnlyCampaign',
  ]),
};
export const DeliveryColumn = {
  name: 'Delivery',
  property: ['DeliveryStatus',
    'DeliveryStatusDetails',
    'QualityScore',
    'NegativeKeywordConflictDetails',
    'BidBelowFirstPageDetail',
    'BidEstimate',
    'Id'],
};

export const QualityScoreColumn = {
  name: 'QualityScore',
  property: 'QualityScore',
};

export const LandingPageColumn = {
  name: 'LandingPage',
  property: ['DestinationUrl', 'FinalUrls', 'MobileFinalUrls'],
};

export const CustomParametersColumn = {
  name: 'CustomParameters',
  property: 'UrlCustomParameters',
};

export const TrackingTemplateColumn = {
  name: 'TrackingTemplate',
  property: 'TrackingUrlTemplate',
};

export const FinalUrlSuffixColumn = {
  name: 'FinalUrlSuffix',
  property: 'FinalUrlSuffix',
};

export const Param1Column = {
  name: 'Param1',
  property: 'Param1',
};

export const Param2Column = {
  name: 'Param2',
  property: 'Param2',
};

export const Param3Column = {
  name: 'Param3',
  property: 'Param3',
};

export const FirstPageBidEstimationColumn = {
  name: 'FirstPageBidEstimation',
  property: 'BidEstimate/FirstPageBidEstimation',
};

export const MainlineBidEstimationColumn = {
  name: 'MainlineBidEstimation',
  property: 'BidEstimate/MainlineBidEstimation',
};

export const BestPositionBidEstimationColumn = {
  name: 'BestPositionBidEstimation',
  property: 'BidEstimate/BestPositionBidEstimation',
};

export const KeywordIdColumn = {
  name: 'KeywordId',
  property: 'Id',
};

export const LabelsColumn = {
  name: 'Labels',
  property: 'Labels',
};

export const getLockedColumns = ({ scope }) => {
  const { campaignId, adGroupId } = scope;
  const baseLockedColumns = _.compact([
    'Status',
    'Keyword',
    !campaignId && 'Campaign',
    !adGroupId && 'AdGroup',
    'MatchType',
  ]);
  return baseLockedColumns;
};

export const getSelectedColumns = ({ scope }) => {
  const { campaignId, adGroupId } = scope;
  const baseSelectedColumns = _.compact([
    KeywordStatusColumn,
    KeywordColumn,
    !campaignId && CampaignColumn,
    !adGroupId && AdGroupColumn,
    isPortfolioBidStrategyEnabled && BidStrategyNameColumn,
    BidStrategyTypeColumn,
    DeliveryColumn,
    BidColumn,
    MatchTypeColumn,
    LabelsColumn,
    RSAAdCustomizerAttributesColumn,
    'Clicks',
    'Impressions',
    'CTR',
    'AverageCPC',
    'Spend',
    'AveragePosition',
    IsAvgPositionDeprecationPhase1Enabled && 'TopImpressionRate',
    IsAvgPositionDeprecationPhase1Enabled && 'AbsoluteTopImpressionRate',
  ]);
  return baseSelectedColumns;
};

export function getColumnsMap({ gridName }) {
  const baseColumns = [
    KeywordStatusColumn,
    KeywordColumn,
    CampaignColumn,
    AdGroupColumn,
    BidStrategyNameColumn,
    BidStrategyTypeColumn,
    BidColumn,
    MatchTypeColumn,
    DeliveryColumn,
    QualityScoreColumn,
    LandingPageColumn,
    CustomParametersColumn,
    TrackingTemplateColumn,
    FinalUrlSuffixColumn,
    Param1Column,
    Param2Column,
    Param3Column,
    FirstPageBidEstimationColumn,
    MainlineBidEstimationColumn,
    BestPositionBidEstimationColumn,
    KeywordIdColumn,
    LabelsColumn,
    RSAAdCustomizerAttributesColumn,
  ];
  const baseRawBIColumns = generateBaseBIColumns(getListOfRawBIColumns(gridName));
  const columns = [...baseColumns, ...baseRawBIColumns];
  return _.object(_.map(columns, column => [column.name, column.property]));
}
